import { render, staticRenderFns } from "./channelSelect.vue?vue&type=template&id=c29aba16&scoped=true&"
import script from "./channelSelect.vue?vue&type=script&lang=js&"
export * from "./channelSelect.vue?vue&type=script&lang=js&"
import style0 from "./channelSelect.vue?vue&type=style&index=0&id=c29aba16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29aba16",
  null
  
)

export default component.exports